export default __webpack_public_path__ + "static/boots.cover-c3a7ab643d433c39b3963b5059f357ad.jpg";